import moment from 'moment';
import RestaurantAutocomplete from '@/components/sales/Autocomplete';
import * as yup from 'yup';
import Autocomplete from '@/components/users/Autocomplete';
import users from '@/constants/users';

export const paymentTypes = [
	{
		value: 0,
		label: 'Weekly',
	},
	{
		value: 1,
		label: 'Bi-Weekly',
	},
	{
		value: 2,
		label: 'Monthly ',
	},
];

export default {
	columns: [
		{ isSortable: true, key: 'id', label: 'Id', initialSort: true, initialSortDirection: 'desc' },
		{ isSortable: true, key: 'docDate', label: 'docDate' },
		{ key: 'status', label: 'Status' },
		{ isSortable: true, key: 'restaurantName', label: 'Restaurant', keyProp: 'restaurant.restaurantName' },
		{ key: 'officialNo', label: 'Off.#' },
		{ key: 'officialDate', label: 'Off.Date' },
		{ key: 'sales', label: 'sales' },
		{ isSortable: true, key: 'subtotal', label: 'subtotal' },
		{ isSortable: true, key: 'vat', label: 'VAT' },
		{ isSortable: true, key: 'total', label: 'Total' },
		{ isSortable: true, key: 'paid', label: 'paid' },
		{ isSortable: true, key: 'unpaid', label: 'unpaid' },
	],
	paymentStatistics: [
		{ title: 'TotalAmountNoVat', propValue: 'TotalAmountNoVat', propKey: 'TotalAmountNoVat' },
		{ title: 'TotalVat', propValue: 'TotalVat', propKey: 'TotalVat' },
		{ title: 'TotalAmountWithVat', propValue: 'TotalAmountWithVat', propKey: 'TotalAmountWithVat' },
		{ title: 'TotalPaidInvoice', propValue: 'TotalPaidInvoice', propKey: 'TotalPaidInvoice' },
		{ title: 'TotalUnPaidInvoice', propValue: 'TotalUnPaidInvoice', propKey: 'TotalUnPaidInvoice' },
		{ title: 'TotalPeriodPayments', propValue: 'TotalPeriodPayments', propKey: 'TotalPeriodPayments' },
	],
	defaultFilters: {
		localStatus: '',
		isFullBody: false,
		limit: 100,
		offset: 0,
		paymentStatus: '',
		businessIDs: [],
		startDate: moment()
			.add(-30, 'day')
			.format('YYYY-MM-DD'),
		endDate: moment().format('YYYY-MM-DD'),
	},
	percentageFilters: {
		limit: 50,
		offset: 0,
		businessIDs: [],
	},
	percentageColumns: [
		{ isSortable: true, key: 'restaurantID', label: 'ID', initialSort: true, initialSortDirection: 'asc' },
		{ isSortable: true, key: 'restaurantName', label: 'Restaurant', keyProp: 'restaurantName' },
		{ isSortable: true, key: 'baboonPercentage', label: 'Baboon %' },
		{ isSortable: true, key: 'courierPercentage', label: 'Courier %' },
		{ isSortable: true, key: 'marketingPercentage', label: 'Marketing %' },
		{ isSortable: true, key: 'vat', label: 'VAT' },
		{ key: 'paymentTermsType', label: 'Invoiced Term' },
		{ key: 'baboonCourier', label: 'Baboon Courier' },
		{ key: 'includeTransportInFee', label: 'Transport Fee' },
		{ key: 'mobilePrinter', label: 'GSM Printer' },
		{ key: 'accManager', label: 'Acc. Manager' },
	],
	percentageSchema: {
		restaurantID: {
			component: RestaurantAutocomplete,
			canDeselect: false,
			name: 'Restaurant',
			placeholder: 'Restaurant',
			disabled: true,
			validations: yup
				.string()
				.required()
				.label('Restaurant'),
		},
		baboonPercentage: {
			component: 'app-input',
			type: 'Number',
			step: 0.5,
			name: 'Baboon %',
			placeholder: 'Baboon %',
			min: 0,
			validations: yup
				.string()
				.required()
				.label('Baboon %'),
		},
		courierPercentage: {
			component: 'app-input',
			type: 'number',
			step: 0.1,
			name: 'Courier %',
			placeholder: 'Courier %',
			min: 0,
			validations: yup
				.string()
				.required()
				.label('Courier %'),
		},
		marketingPercentage: {
			component: 'app-input',
			type: 'number',
			step: 0.1,
			name: 'Marketing %',
			placeholder: 'Marketing %',
			min: 0,
			validations: yup
				.string()
				.required()
				.label('Marketing %'),
		},
		vat: {
			component: 'app-input',
			type: 'number',
			name: 'Vat',
			placeholder: 'Vat',
			min: 0,
			validations: yup
				.string()
				.required()
				.label('Vat'),
		},
		paymentTermsType: {
			component: 'app-select',
			class: 'mb-6',
			options: paymentTypes,
			canDeselect: false,
			searchable: true,
			name: 'Invoiced Term',
			placeholder: 'Invoiced Term',
		},
		accManager: {
			component: Autocomplete,
			name: 'AccManager',
			userType: users.userTypes['agent'],
			placeholder: 'Account Manager',
		},
		includeTransportInFee: {
			component: 'app-checkbox',
			customClass: 'mb-3, text-lg',
			name: 'Transport Fee',
			label: 'Transport Fee',
		},
		baboonCourier: {
			component: 'app-checkbox',
			customClass: 'mb-3, text-lg',
			name: 'Baboon Courier',
			label: 'Baboon Courier',
		},
		mobilePrinter: {
			component: 'app-checkbox',
			customClass: 'mb-3, text-lg',
			name: 'Mobile Printer',
			label: 'Mobile Printer',
		},
	},
	paymentTermTypes: paymentTypes,
	paymentsDefaultFilters: {
		limit: 50,
		offset: 0,
		startDate: moment()
			.add(-30, 'day')
			.format('YYYY-MM-DD'),
		endDate: moment().format('YYYY-MM-DD'),
	},
	paymentColumns: [
		{ key: 'id', label: 'Id', initialSort: true, initialSortDirection: 'desc', isSortable: true },
		{ key: 'docDate', label: 'docDate', isSortable: true },
		{ key: 'restaurant', label: 'business' },
		{ key: 'paymentUnit', label: 'invoiceTerm' },
		{ key: 'invoiceID', label: 'invoiceID' },
		{ key: 'invoiceDate', label: 'invoiceDate' },
		{ key: 'accManager', label: 'Acc Manager' },
		{ key: 'amountCents', label: 'amountCents', isSortable: true },
	],
};
